import { render, staticRenderFns } from "./sickness.vue?vue&type=template&id=84ff73ae&"
import script from "./sickness.vue?vue&type=script&lang=js&"
export * from "./sickness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports